import { useQuery } from '@tanstack/react-query'
import { useOperator } from './OperatorServices'

export const missionKeys = {
  home: (userId: string) => ['home', userId] as const,
  /** Sous la clé de l'accueil : relu avec lui après un départ ou une fin de sortie. */
  routePlan: (userId: string) => ['home', userId, 'route-plan'] as const,
  view: (userId: string, missionId: string) => ['mission', userId, missionId] as const,
  track: (userId: string, missionId: string) => ['track', userId, missionId] as const,
}

export function useHome() {
  const { userId, repository } = useOperator()
  return useQuery({ queryKey: missionKeys.home(userId), queryFn: () => repository.home() })
}

/**
 * Routes de l'opérateur dans l'ordre du bureau (contrats 0.6.0). Un échec laisse l'accueil historique : route
 * principale seule, départ sans route choisie.
 */
export function useRoutePlan() {
  const { userId, repository } = useOperator()
  return useQuery({ queryKey: missionKeys.routePlan(userId), queryFn: () => repository.routePlan(), retry: 1 })
}

export function useMissionView(missionId: string) {
  const { userId, repository } = useOperator()
  return useQuery({
    queryKey: missionKeys.view(userId, missionId),
    queryFn: () => repository.view(missionId),
    refetchOnWindowFocus: true,
  })
}

/** Trace enregistrée (affichage seulement) : relue chaque minute quand l'option est active. */
export function useMissionTrack(missionId: string, enabled: boolean) {
  const { userId, repository } = useOperator()
  return useQuery({
    queryKey: missionKeys.track(userId, missionId),
    queryFn: () => repository.track(missionId),
    enabled,
    refetchInterval: enabled ? 60_000 : false,
  })
}
